module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_menu-c79e32fa1ebb1bcabdd782445f824593.svg";